import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import z from 'zod';
import { api } from '@/lib/api-client';
import { QueryConfig } from '@/lib/tanstack-query';
import { Order } from '@/types/api/order';

export const ListOrdersSortKeySchema = z.enum(['createdAt', 'updatedAt']);

export const ListOrdersParamsSchema = z.object({}).partial();

export type ListOrdersParams = z.infer<typeof ListOrdersParamsSchema>;

export const listOrders = async (params: ListOrdersParams): Promise<Order[]> => {
  return (await api.get(`/orders`, { params })).data;
};

export const listOrdersQueryOptions = (params: ListOrdersParams = {}) => {
  return queryOptions({
    queryKey: ['orders', params],
    queryFn: () => listOrders(params),
    enabled: Boolean(params),
  });
};

type UseOrdersOptions = {
  queryConfig?: QueryConfig<typeof listOrdersQueryOptions>;
  params?: ListOrdersParams;
};

export const useOrders = ({ queryConfig, params }: UseOrdersOptions) => {
  return useQuery({
    ...listOrdersQueryOptions(params),
    ...queryConfig,
  });
};

export const useOrdersSuspense = ({ queryConfig, params }: UseOrdersOptions) => {
  return useSuspenseQuery({
    ...listOrdersQueryOptions(params),
    ...queryConfig,
  });
};
